import { useQuery } from '@tanstack/react-query';
import { isListEnabled } from 'utils/queryHelpers';

import { QueryContextFromKeys, QueryParamModel } from 'models';
import { statisticsService } from 'services';

type ReportCodesQueryContexts = QueryContextFromKeys<typeof ReportCodesKeys>;

export const ReportCodesKeys = {
  all: [{ scope: 'reportCodes' }] as const,
  lists: () => [{ ...ReportCodesKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) => [{ ...ReportCodesKeys.lists()[0], params }] as const,
};

const fetchReportCodesList = async ({ queryKey: [{ params }] }: ReportCodesQueryContexts['list']) =>
  statisticsService.getReportCodesList(params);

const exportReportCodes = async ({ queryKey: [{ params }] }: ReportCodesQueryContexts['list']) =>
  statisticsService.exportReportCodes(params);

export const useReportCodesList = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: ReportCodesKeys.list(params),
    queryFn: fetchReportCodesList,
    enabled: isListEnabled(params),
  });
};

export const useExportReportCodes = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: ReportCodesKeys.list(params),
    queryFn: exportReportCodes,
    enabled: false,
  });
};
